import React, {useCallback, useMemo} from 'react';
import type {SxProps} from '@mui/material';
import {Grid} from '@mui/material';
import {ColorPalette} from 'theme';
import {IconButton, Text} from 'components';
import type {ItemAction, ItemProps} from '../types';

const ContainerSx: SxProps = {
  height: 40,
  display: 'flex',
  alignItems: 'stretch',
  borderRadius: 1,
  backgroundColor: ColorPalette.primary.lightGreen,
  paddingLeft: '10px',
};

const TextSx: SxProps = {
  color: ColorPalette.primary.burgundy,
  alignContent: 'center',
};

const GridBoxSx: SxProps = {
  display: 'flex',
};

export const ListItem: React.FC<ItemProps> = ({
  label,
  active,
  onClick,
  actions,
  disabled,
  sxProps,
}) => {
  const WrapperSx = useMemo(() => {
    const sx = {
      width: '100%',
      ...ContainerSx,
      ...sxProps,
    };

    if (active) {
      return {
        ...sx,
        backgroundColor: ColorPalette.primary.warmGreen,
      };
    }

    return sx;
  }, [active, sxProps]);

  const ItemActions = useCallback(
    (position: ItemAction['position']) => {
      const items = (actions ?? [])
        .filter(a => a.position === position)
        .map(a => <IconButton key={a.props.icon} {...a.props} />);

      if (!items || !items.length) {
        return undefined;
      }
      return <Grid size={{xs: 'auto'}}>{items}</Grid>;
    },
    [actions],
  );

  return (
    <Grid container sx={WrapperSx} flexDirection="row">
      {ItemActions('beforeText')}
      <Grid
        size={{xs: 'grow'}}
        onClick={disabled ? undefined : onClick}
        sx={{...GridBoxSx, cursor: disabled ? 'initial' : 'pointer'}}>
        <Text
          variant="h4"
          sx={{
            ...TextSx,
            opacity: disabled ? 0.5 : 1,
          }}>
          {label}
        </Text>
      </Grid>
      {ItemActions('afterText')}
    </Grid>
  );
};
